var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoPocket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_625_4619)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5475 3.99854H57.6894H15.9141H14.4141V5.49854V15.139V41.765V42.5549L15.0653 43.0018L18.187 45.1441L20.3513 42.991L17.4141 40.9752V17.3173L38.1864 25.2486L40.5191 22.928L17.4141 14.1061V6.99854H56.5318L59.5475 3.99854ZM55.2201 17.369L63.0754 14.1345V9.55448L66.0754 6.57007V15.139V42.6832V43.5324L65.3472 43.9694L64.5754 42.6832C65.3472 43.9694 65.3471 43.9694 65.347 43.9695L65.3464 43.9699L65.3454 43.9704L65.3441 43.9712L65.3349 43.9767L65.2986 43.9985L65.1561 44.0841L64.6075 44.4132L62.5856 45.6264L55.8789 49.6504L40.0983 59.1187L39.2722 59.6144L38.4778 59.0692L23.5796 48.845L25.744 46.6918L39.381 56.0505L54.3354 47.0779L61.0421 43.0539L63.064 41.8407L63.0754 41.8339V17.3788L49.6554 22.9047L55.2201 17.369Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.3987,
    y: 0.5,
    width: 2.75442,
    height: 77.1237,
    transform: "rotate(45.915 66.3987 0.5)",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_625_4619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 59,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPocket);
export default __webpack_public_path__ + "static/media/no_pocket.433469421f2ef5755bcfc4ea96283c81.svg";
export { ForwardRef as ReactComponent };